module.exports = __webpack_public_path__ + "img/carton-fragile-plein-bleu.svg";